import { render } from "./PriceChangeTabs.vue?vue&type=template&id=75d9225c&scoped=true"
import script from "./PriceChangeTabs.vue?vue&type=script&lang=js"
export * from "./PriceChangeTabs.vue?vue&type=script&lang=js"

import "./PriceChangeTabs.vue?vue&type=style&index=0&id=75d9225c&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d9225c"],['__file',"resources/js/components/PriceChangeTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75d9225c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75d9225c', __exports__)) {
    api.reload('75d9225c', __exports__)
  }
  
  module.hot.accept("./PriceChangeTabs.vue?vue&type=template&id=75d9225c&scoped=true", () => {
    api.rerender('75d9225c', render)
  })

}


export default __exports__